// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section {
  min-height: 100vh;
}
.section.section--auto {
  min-height: auto;
}
.section.modal {
  position: fixed;
  z-index: 99999;
  background-color: var(--secondary-color-0);
  height: 100vh;
  width: 100%;
  top: 0;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease-in-out 0s;
}
.section.modal.opaque {
  background-color: rgba(0, 0, 0, 0.3);
}
.section.modal > div > div {
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease-in-out 0s;
}
.section.show {
  animation: fadein 0.5s;
  opacity: 1;
  visibility: visible;
  transition: all 0.5s ease-in-out 0s;
}
.section.show > div > div {
  animation: fadein 0.5s;
  opacity: 1;
  visibility: visible;
  transition: all 0.5s ease-in-out 0s;
}
.section .fadein {
  animation: fadein 1s;
}
.section .fadeout {
  animation: fadeout 1s;
}
.section .section--item {
  border-radius: 10px;
  padding: 28px 30px;
  display: flex;
  justify-content: space-between;
}
.section .section--item.white {
  background-color: var(--secondary-color-0);
}
.section .section--item > p, .section .section--item.icon-set > div > p {
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 500;
  margin: 0;
}
.section .section--item.icon-set {
  justify-content: flex-start;
}
.section .section--item.icon-set > div > img {
  padding-right: 20px;
}
.section .close-icon {
  background-color: var(--secondary-color-1);
  padding: 5px 8px;
  border-radius: 10px;
  cursor: pointer;
  align-self: center;
}
.section .close-icon > img {
  width: 10.5px;
}
.section .close-icon .section--headline {
  text-align: center;
  letter-spacing: 15px;
}
.section .close-icon .bg-color--gray {
  background-color: var(--secondary-color-4);
}
.section .close-icon .bg-color--white {
  background-color: var(--secondary-color-0);
}
.section .homepage-search select {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 600;
}
.section .homepage-search .search-input {
  border-radius: 0 !important;
  height: 45px;
  font-family: "Proxima Nova", sans-serif;
  font-weight: 500;
}
.section .homepage-search .button {
  height: 45px;
  font-size: 14px;
  font-family: "Proxima Nova", sans-serif;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .section--headline {
    letter-spacing: 5px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .section--headline {
    letter-spacing: 5px;
  }
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Section/section.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ;AAGI;EACI,gBAAA;AADR;AAII;EACI,eAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,WAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EAIA,mCAAA;AAFR;AAIQ;EACI,oCAAA;AAFZ;AAKQ;EACI,UAAA;EACA,kBAAA;EACA,mCAAA;AAHZ;AAOI;EACI,sBAAA;EACA,UAAA;EACA,mBAAA;EACA,mCAAA;AALR;AAOQ;EACI,sBAAA;EACA,UAAA;EACA,mBAAA;EACA,mCAAA;AALZ;AASI;EACI,oBAAA;AAPR;AAUI;EACI,qBAAA;AARR;AAWI;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AATR;AAWQ;EACI,0CAAA;AATZ;AAYQ;EAEI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAXZ;AAcQ;EACI,2BAAA;AAZZ;AAcY;EACI,mBAAA;AAZhB;AAiBI;EACI,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAfR;AAiBQ;EACI,aAAA;AAfZ;AAkBQ;EACI,kBAAA;EACA,oBAAA;AAhBZ;AAmBQ;EACI,0CAAA;AAjBZ;AAoBQ;EACI,0CAAA;AAlBZ;AAuBQ;EACI,uCAAA;EACA,gBAAA;AArBZ;AAwBQ;EACI,2BAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;AAtBZ;AAyBQ;EACI,YAAA;EACA,eAAA;EACA,uCAAA;AAvBZ;;ACnGY;EDiIR;IACI,mBAAA;EA1BN;AACF;AClGY;ED0HR;IACI,mBAAA;EArBN;AACF;AAwBA;EACI;IACI,UAAA;EAtBN;EAyBE;IACI,UAAA;EAvBN;AACF;AA0BA;EACI;IACI,UAAA;EAxBN;EA2BE;IACI,UAAA;EAzBN;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.section {\r\n    min-height: 100vh;\r\n\r\n    &.section--auto {\r\n        min-height: auto;\r\n    }\r\n\r\n    &.modal {\r\n        position: fixed;\r\n        z-index: 99999;\r\n        background-color: var(--secondary-color-0);\r\n        height: 100vh;\r\n        width: 100%;\r\n        top: 0;\r\n        overflow: hidden;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        -webkit-transition: all 0.5s ease-in-out 0s;\r\n        -moz-transition: all 0.5s ease-in-out 0s;\r\n        -ms-transition: all 0.5s ease-in-out 0s;\r\n        transition: all 0.5s ease-in-out 0s;\r\n\r\n        &.opaque {\r\n            background-color: rgba(#000000, .3);\r\n        }\r\n\r\n        >div>div {\r\n            opacity: 0;\r\n            visibility: hidden;\r\n            transition: all 0.5s ease-in-out 0s;\r\n        }\r\n    }\r\n\r\n    &.show {\r\n        animation: fadein .5s;\r\n        opacity: 1;\r\n        visibility: visible;\r\n        transition: all 0.5s ease-in-out 0s;\r\n\r\n        >div>div {\r\n            animation: fadein .5s;\r\n            opacity: 1;\r\n            visibility: visible;\r\n            transition: all 0.5s ease-in-out 0s;\r\n        }\r\n    }\r\n\r\n    .fadein {\r\n        animation: fadein 1s;\r\n    }\r\n\r\n    .fadeout {\r\n        animation: fadeout 1s;\r\n    }\r\n\r\n    .section--item {\r\n        border-radius: 10px;\r\n        padding: 28px 30px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n\r\n        &.white {\r\n            background-color: var(--secondary-color-0);\r\n        }\r\n\r\n        >p,\r\n        &.icon-set>div>p {\r\n            font-family: 'Roboto', sans-serif;\r\n            font-size: 20px;\r\n            font-weight: 500;\r\n            margin: 0;\r\n        }\r\n\r\n        &.icon-set {\r\n            justify-content: flex-start;\r\n\r\n            >div>img {\r\n                padding-right: 20px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .close-icon {\r\n        background-color: var(--secondary-color-1);\r\n        padding: 5px 8px;\r\n        border-radius: 10px;\r\n        cursor: pointer;\r\n        align-self: center;\r\n\r\n        >img {\r\n            width: 10.5px;\r\n        }\r\n\r\n        .section--headline {\r\n            text-align: center;\r\n            letter-spacing: 15px;\r\n        }\r\n\r\n        .bg-color--gray {\r\n            background-color: var(--secondary-color-4);\r\n        }\r\n\r\n        .bg-color--white {\r\n            background-color: var(--secondary-color-0);\r\n        }\r\n    }\r\n\r\n    .homepage-search {\r\n        select {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 600;\r\n        }\r\n\r\n        .search-input {\r\n            border-radius: 0 !important;\r\n            height: 45px;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .button {\r\n            height: 45px;\r\n            font-size: 14px;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@include media(mobile, tablet) {\r\n    .section--headline {\r\n        letter-spacing: 5px;\r\n    }\r\n}\r\n\r\n@keyframes fadein {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes fadeout {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
